import { ranking } from '@/mocks/siteData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">本周最劲爆的影视圈猛料排名</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {ranking.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-44 md:h-48 object-cover object-top"
                  title={item.title}
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-flex items-center justify-center w-8 h-8 rounded-lg text-sm font-bold ${
                    item.rank === 1 ? 'bg-primary-500 text-background-50' :
                    item.rank === 2 ? 'bg-accent-500 text-background-50' :
                    item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                    'bg-foreground-700 text-background-50'
                  }`}>
                    {item.rank}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="text-xs px-2 py-1 bg-background-50/90 text-foreground-700 rounded-full whitespace-nowrap">
                    {item.heat}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs text-primary-600 font-medium">{item.category}</span>
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mt-1.5 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 mt-2">
                  {item.change === 'up' && (
                    <span className="text-xs text-accent-600 flex items-center gap-0.5">
                      <i className="ri-arrow-up-line text-xs"></i>上升中
                    </span>
                  )}
                  {item.change === 'down' && (
                    <span className="text-xs text-foreground-400 flex items-center gap-0.5">
                      <i className="ri-arrow-down-line text-xs"></i>下降
                    </span>
                  )}
                  {item.change === 'same' && (
                    <span className="text-xs text-foreground-400 flex items-center gap-0.5">
                      <i className="ri-subtract-line text-xs"></i>持平
                    </span>
                  )}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}